export enum RtDebugAngularType {
  Directive,
  Component,
  Injectable,
}

export function recognizeAngularType(classBody: any): RtDebugAngularType {
  const classBodyAnnotations = classBody.hasOwnProperty('__annotations__')
    ? classBody.__annotations__
    : [];

  // directives must have selectors
  const isDirective = classBodyAnnotations.length > 0 && !!classBodyAnnotations[0].selector;

  // component is basically directive with template
  const isComponent =
    classBodyAnnotations.length > 0 &&
    ((isDirective && !!classBodyAnnotations[0].template) || !!classBodyAnnotations[0].templateUrl);

  if (isDirective || isComponent) {
    return isComponent ? RtDebugAngularType.Component : RtDebugAngularType.Directive;
  }

  // if both above fails, we assume it's a just injectable class
  return RtDebugAngularType.Injectable;
}

export function isComponentOrDirective(type: RtDebugAngularType): boolean {
  return type === RtDebugAngularType.Directive || type === RtDebugAngularType.Component;
}
